import React from 'react';
import { Button } from 'react-bootstrap';

type Props = {
  title: string;
  disabled: boolean;
  isProcessing?: boolean;
  onClick?: () => void;
};

const SubmitButton: React.FC<Props> = ({
  title,
  disabled,
  isProcessing,
  onClick,
}) => {
  return (
    <Button
      type={onClick ? 'button' : 'submit'}
      size="sm"
      disabled={disabled}
      onClick={onClick}
      className="ms-2 d-flex align-items-center">
      {isProcessing && (
        <span
          className="spinner-border spinner-border-sm me-2"
          role="status"
          aria-hidden="true"></span>
      )}
      <span>{title}</span>
    </Button>
  );
};

export default SubmitButton;
